// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forward-modal .modal-container {
  width: 480px !important;
  height: auto !important;
}
.forward-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.forward-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 2rem !important;
  padding-bottom: 1.75rem !important;
}
.forward-modal button.primary {
  width: 100%;
}
.forward-modal button.tertiary-text-underlined {
  width: 100%;
  color: #FF2459;
}

.platform-select {
  justify-content: start !important;
}

.check-modal .checkbox1 .checkbox-wrapper.checked .checkbox-select {
  background-color: #FF2459 !important;
  border: #FF2459 !important;
}
.check-modal .modal-container {
  width: 480px !important;
  height: 360px !important;
}
.check-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.check-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 1.5rem !important;
  padding-bottom: 1.25rem !important;
}

.verify-ticket .modal-container {
  width: 380px !important;
  height: auto !important;
}
.verify-ticket .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.verify-ticket .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 0 !important;
}

.fail-modal .modal-container {
  width: 480px !important;
  height: auto !important;
}
.fail-modal .modal-container .modal-header {
  border-bottom: 0 !important;
  padding: 0 !important;
}
.fail-modal .modal-container .modal-content {
  height: auto;
  overflow: auto;
  padding: 2rem !important;
}
.fail-modal button.primary {
  width: 100%;
}

@media (min-width: 370px) and (max-width: 635px) { /* sm breakpoint in Tailwind CSS */
  .forward-modal .modal-container {
    width: 80vw !important;
    height: auto !important;
  }
  .forward-modal .modal-container .modal-header {
    border-bottom: 0 !important;
    padding: 0 !important;
  }
  .forward-modal .modal-container .modal-content {
    height: auto;
    overflow: auto;
    padding: 1.5rem !important;
    padding-bottom: 1.25rem !important;
  }
  .forward-modal button.primary {
    width: 100%;
  }
  .forward-modal button.tertiary-text-underlined {
    width: 100%;
    color: #FF2459;
  }
  .fail-modal .modal-container {
    width: 80vw !important;
    height: auto !important;
  }
  .fail-modal .modal-container .modal-header {
    border-bottom: 0 !important;
    padding: 0 !important;
  }
  .fail-modal .modal-container .modal-content {
    height: auto;
    overflow: auto;
    padding: 1.5rem !important;
  }
  .fail-modal button.primary {
    width: 100%;
  }
  .check-modal .checkbox1 .checkbox-wrapper.checked .checkbox-select {
    background-color: #FF2459 !important;
    border: #FF2459 !important;
  }
  .check-modal .modal-container {
    width: 330px !important;
    height: auto !important;
  }
  .check-modal .modal-container .modal-header {
    border-bottom: 0 !important;
    padding: 0 !important;
  }
  .check-modal .modal-container .modal-content {
    height: auto;
    overflow: auto;
    padding: 1.5rem !important;
  }
  .info-card-wrapper {
    gap: 10px !important;
    padding: 12px 16px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/sell-tickets/components/style.scss"],"names":[],"mappings":"AAGE;EACC,uBAAA;EACA,uBAAA;AAFH;AAGG;EACG,2BAAA;EACA,qBAAA;AADN;AAGG;EACC,YAAA;EACA,cAAA;EACA,wBAAA;EACA,kCAAA;AADJ;AAKG;EACC,WAAA;AAHJ;AAKG;EACC,WAAA;EACA,cAAA;AAHJ;;AAOA;EACE,iCAAA;AAJF;;AASI;EACE,oCAAA;EACA,0BAAA;AANN;AASE;EACC,uBAAA;EACA,wBAAA;AAPH;AAQG;EACG,2BAAA;EACA,qBAAA;AANN;AAQG;EACC,YAAA;EACA,cAAA;EACA,0BAAA;EACA,kCAAA;AANJ;;AAWE;EACE,uBAAA;EACA,uBAAA;AARJ;AASI;EACG,2BAAA;EACA,qBAAA;AAPP;AASI;EACC,YAAA;EACA,cAAA;EACA,qBAAA;AAPL;;AAgBE;EACC,uBAAA;EACA,uBAAA;AAbH;AAcG;EACG,2BAAA;EACA,qBAAA;AAZN;AAcG;EACC,YAAA;EACA,cAAA;EACA,wBAAA;AAZJ;AAeG;EACC,WAAA;AAbJ;;AAiBA,mDAAA,kCAAA;EAEI;IACC,sBAAA;IACA,uBAAA;EAfH;EAgBG;IACG,2BAAA;IACA,qBAAA;EAdN;EAgBG;IACC,YAAA;IACA,cAAA;IACA,0BAAA;IACA,kCAAA;EAdJ;EAkBG;IACC,WAAA;EAhBJ;EAkBG;IACC,WAAA;IACA,cAAA;EAhBJ;EAsBI;IACC,sBAAA;IACA,uBAAA;EApBL;EAqBK;IACG,2BAAA;IACA,qBAAA;EAnBR;EAqBK;IACC,YAAA;IACA,cAAA;IACA,0BAAA;EAnBN;EAsBK;IACC,WAAA;EApBN;EA4BE;IACE,oCAAA;IACA,0BAAA;EA1BJ;EA6BA;IACC,uBAAA;IACA,uBAAA;EA3BD;EA4BC;IACG,2BAAA;IACA,qBAAA;EA1BJ;EA4BC;IACC,YAAA;IACA,cAAA;IACA,0BAAA;EA1BF;EA8BF;IACE,oBAAA;IACA,6BAAA;EA5BA;AACF","sourcesContent":["\n\n.forward-modal {\n  .modal-container {\n   width: 480px !important;\n   height: auto !important;\n   .modal-header{\n      border-bottom:0 !important;\n      padding:0 !important;\n   }\n   .modal-content {\n    height: auto;\n    overflow: auto;\n    padding:2rem !important;\n    padding-bottom: 1.75rem !important;\n   \n  }\n   }\n   button.primary{\n    width: 100%;\n   }\n   button.tertiary-text-underlined{\n    width: 100%;\n    color:theme('colors.primary')\n   }\n  }\n\n.platform-select {\n  justify-content: start !important;\n}\n\n.check-modal {\n  .checkbox1{\n    .checkbox-wrapper.checked .checkbox-select {\n      background-color: theme('colors.primary') !important;\n      border:theme('colors.primary') !important;\n    }\n  }\n  .modal-container {\n   width: 480px !important;\n   height: 360px !important;\n   .modal-header{\n      border-bottom:0 !important;\n      padding:0 !important;\n   }\n   .modal-content {\n    height: auto;\n    overflow: auto;\n    padding:1.5rem !important; \n    padding-bottom: 1.25rem !important;  \n  }\n  }\n}\n.verify-ticket{\n  .modal-container {\n    width: 380px !important;\n    height: auto !important;\n    .modal-header{\n       border-bottom:0 !important;\n       padding:0 !important;\n    }\n    .modal-content {\n     height: auto;\n     overflow: auto;\n     padding:0 !important;   \n   }\n   }\n\n}\n\n\n\n.fail-modal {\n  .modal-container {\n   width: 480px !important;\n   height: auto !important;\n   .modal-header{\n      border-bottom:0 !important;\n      padding:0 !important;\n   }\n   .modal-content {\n    height: auto;\n    overflow: auto;\n    padding:2rem !important;   \n  }\n  }\n   button.primary{\n    width: 100%;\n   }\n  }\n  \n@media (min-width: 370px ) and (max-width:635px)  { /* sm breakpoint in Tailwind CSS */\n  .forward-modal {\n    .modal-container {\n     width: 80vw !important;\n     height: auto !important;\n     .modal-header{\n        border-bottom:0 !important;\n        padding:0 !important;\n     }\n     .modal-content {\n      height: auto;\n      overflow: auto;\n      padding:1.5rem !important;\n      padding-bottom: 1.25rem !important;\n     \n    }\n     }\n     button.primary{\n      width: 100%;\n     }\n     button.tertiary-text-underlined{\n      width: 100%;\n      color:theme('colors.primary')\n     }\n    }\n    \n\n    .fail-modal {\n      .modal-container {\n       width: 80vw !important;\n       height: auto !important;\n       .modal-header{\n          border-bottom:0 !important;\n          padding:0 !important;\n       }\n       .modal-content {\n        height: auto;\n        overflow: auto;\n        padding:1.5rem !important;       \n      }\n       }\n       button.primary{\n        width: 100%;\n       }\n      }\n      \n  \n\n.check-modal {\n  .checkbox1{\n    .checkbox-wrapper.checked .checkbox-select {\n      background-color: theme('colors.primary') !important;\n      border:theme('colors.primary') !important;\n    }\n  }\n  .modal-container {\n   width: 330px !important;\n   height: auto !important;\n   .modal-header{\n      border-bottom:0 !important;\n      padding:0 !important;\n   }\n   .modal-content {\n    height: auto;\n    overflow: auto;\n    padding:1.5rem !important;   \n  }\n  }\n}\n.info-card-wrapper{\n  gap:10px !important;\n  padding: 12px 16px !important;\n\n  // &.info {\n  //   background-color: theme('colors.primary') !important;\n  // }\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
